import { IconButton, IconButtonProps } from '@chakra-ui/react';
import * as React from 'react';
import ReactMultiCarousel, {
  CarouselProps,
  ResponsiveType,
} from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { ChevronLeftIcon, ChevronRightIcon } from '@/imports/ui/chakra/feather';

// react-multi-carousel renders client custom arrow with an additional prop 'carouselState' that should be stripped out
// https://github.com/YIZHUANG/react-multi-carousel/blob/master/src/Arrows.tsx#L43
const CarouselButton: React.FC<
  IconButtonProps & {
    carouselState?: any;
  }
> = ({ carouselState, ...props }) => {
  return (
    <IconButton
      variant="outline"
      borderRadius="full"
      colorScheme="gray"
      position="absolute"
      opacity="0.7"
      {...props}
    />
  );
};

export const Carousel: React.FC<
  Omit<CarouselProps, 'responsive'> & {
    buttonSpacing?: number;
    numItems?: number;
    responsive?: ResponsiveType;
  }
> = ({ numItems, buttonSpacing, responsive, ...rest }) => {
  return (
    <ReactMultiCarousel
      customRightArrow={
        <CarouselButton
          right={buttonSpacing || 0}
          icon={<ChevronRightIcon />}
          aria-label="Next"
        />
      }
      customLeftArrow={
        <CarouselButton
          left={buttonSpacing || 0}
          icon={<ChevronLeftIcon />}
          aria-label="Previous"
        />
      }
      responsive={
        !!responsive
          ? responsive
          : {
              mobile: {
                breakpoint: { max: 3000, min: 0 },
                items: numItems ?? 2,
              },
            }
      }
      keyBoardControl={true}
      {...rest}
    />
  );
};
